<template>
    <div
        class="a-tiles-search-results"
        :style="componentStyles"
    >
        <h3 class="tiles-search-results-title">
            {{ $t('ui.no-results-title') }}
        </h3>
        <p class="tiles-search-results-text">
            {{ $t('ui.no-results-text') }}
        </p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ATilesSearchResults',
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        componentStyles() {
            return this.getMapConfigProp('components.ATilesSearchResults.styles') || null;
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />